import * as S from "../../Style/Page/Social.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleSocial.js";
import HatPageTopLine from "../../Component/SocialPageTopLine.js";
const Img001 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/01. 영안역사관 소개 (내부).58b87b2b4d2629109b76.png`;
const Img001_1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/02. 영안역사기록관.33d3412d09e63663553f.png`;
const Img001_2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/03. 지게차100주년역사관.af4de408fc5fe8bd1472.png`;
const Img001_3 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/04. 숭의역사관(대방동).998a5788d824594662ff.png`;
const Img001_4 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/05. 숭의역사관(남산).e1bef7c36c43dc78401d.png`;
const Img001_5 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/06. 숭의인물관.b157a0a059c3197336c2.png`;
const Img001_6 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/07. 백학마을 역사관.0d3804f78a7b3b73585b.png`;
const Img002 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/08. 영안역사관 소개 (외부).4fea14c4b96d6a8dc97c.png`;
const Img002_1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/09. 보석역사관.5b28f9be0b47ad4509cc.png`;
const Img002_2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/10. 자동차미니역사관.fa2b619b3d401105a01d.png`;
const Img002_3 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/11. 외교구락부역사관.2d24a4771a8a2b0d60e5.png`;
const Img002_4 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/12. 방송역사관.ca11e39afe6cd4a566d5.png`;
const Img002_5 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/13. 단성사영화역사관.5c8f159c8b6458c49253.png`;
const Img002_6 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/14. 천체우주역사관.42765dd44f454bf4bbef.png`;
const Scholarship = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"사회사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/SocialBusiness/SocialService">
                <div className="kor">사회사업</div>
                <div className="eng">Social Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"260px"}>
            <S.NavItem>
              <Link to="/SocialBusiness/Museum">
                <div className="kor">영안역사관</div>
                <div className="eng">YoungAn History Museum</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">복지사업</div>
                  <div className="eng">Welfare Services</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/Scholarship">
                  <div className="kor">연암장학회</div>
                  <div className="eng">Yeonam Scholarship Foundation</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/EducationBusiness">
                  <div className="kor">교육사업</div>
                  <div className="eng">YoungAn Education Business</div>
                </Link>
              </S.NavItem>
              
              
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/Obs">OBS</Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/Museum">
                  <div className="kor">영안역사관</div>
                  <div className="eng">YoungAn History Museum</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"영안역사관"} titleeng={"YoungAn History Museum"} />

            <div className="page-text text-br-no">
              <div className="kor">
                현재 사회적으로 인정받는 순서는 외교구락부 / 영화역사관 /<br />
                방송역사관 / 자동차미니역사관 / 보석역사관으로, 영안은 중요한
                <br />
                역사가 있는 곳에 역사관을 설치하고 있습니다.
              </div>
              <div className="eng">
                In Current Socially Recognized Order / Diplomatic Club History Museum / Dansungsa Movie History Museum
                <br />/ Broadcasting History Museum / Automobile History Museum / Juwelry History Museum
              </div>
            </div>
            <PageTitle titleko={"영안역사관 / 내부"} titleeng={"YoungAn History Museum (Inside)"} />
            <img src={Img001} alt="" className="fullsize-map" />


            <div className="kor">
              <S.MuseumTextItemLine>
                <S.MuseumTextItem color={"#603913"}>
                  <div className="museum-top">
                    <div className="museum-title">영안역사기록관</div>
                    <div className="museum-subtitle">YoungAn History Hall</div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">설립년도</div>
                    <div className="intro-text">2009년 설립</div>
                    <div className="intro-text-sm">※창립 50주년 기념</div>

                    <div className="intro-title">위 치</div>
                    <div className="intro-text">부천 / 영안모자 본사</div>

                    <div className="intro-title">비 고</div>
                    <div className="intro-text">2019년 리모델링</div>
                  </div>
                </S.MuseumTextItem>
                <S.MuseumTextItem color={"#D7DF23"}>
                  <div className="museum-top">
                    <div className="museum-title">지게차 100주년 역사관</div>
                    <div className="museum-subtitle">CLACK Centennial Hall</div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">설립년도</div>
                    <div className="intro-text">2017년 설립</div>
                    <div className="intro-text-sm">※지게차 100주년 기념</div>

                    <div className="intro-title">위 치</div>
                    <div className="intro-text">창원 공장</div>
                    <div className="intro-text">부천 전시장</div>
                    <div className="intro-text">미국 공장</div>
                    <div className="intro-text">독일 공장 (4곳에 배치)</div>
                  </div>
                </S.MuseumTextItem>
                <S.MuseumTextItem color={"#A4C7A3"}>
                  <div className="museum-top">
                    <div className="museum-title">숭의역사관 (대방동)</div>
                    <div className="museum-subtitle">Soongeul Histroy Hall</div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">설립년도</div>
                    <div className="intro-text">2003년 설립</div>
                    <div className="intro-text-sm">※학원창립 100주년 기념</div>

                    <div className="intro-title">위 치</div>
                    <div className="intro-text">서울 대방동 / </div>
                    <div className="intro-text">숭의여자고등학교</div>
                  </div>
                </S.MuseumTextItem>
                <S.MuseumTextItem color={"#A97B50"}>
                  <div className="museum-top">
                    <div className="museum-title">숭의역사관 (남산)</div>
                    <div className="museum-subtitle">Soongeul Histroy Hall</div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">설립년도</div>
                    <div className="intro-text">2013년 설립</div>
                    <div className="intro-text-sm">※학원창립 110주년 기념</div>

                    <div className="intro-title">위 치</div>
                    <div className="intro-text">서울 남산 / </div>
                    <div className="intro-text">숭의여자대학교</div>

                    <div className="intro-title">비 고</div>
                    <div className="intro-text">2023년 120주년 기념</div>
                    <div className="intro-text">부분 리모델링</div>
                  </div>
                </S.MuseumTextItem>
                <S.MuseumTextItem color={"#726658"}>
                  <div className="museum-top">
                    <div className="museum-title">숭의인물관</div>
                    <div className="museum-subtitle">Hall of Soongeul Fame</div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">설립년도</div>
                    <div className="intro-text">2015년 설립</div>

                    <div className="intro-title">위 치</div>
                    <div className="intro-text">서울 남산 / </div>
                    <div className="intro-text">숭의여자대학교</div>

                    <div className="intro-title">비 고</div>
                    <div className="intro-text">안중근의사 동상 / </div>
                    <div className="intro-text">1959년 (독립운동)</div>
                  </div>
                </S.MuseumTextItem>
                <S.MuseumTextItem color={"#7783BD"}>
                  <div className="museum-top">
                    <div className="museum-title">백학마을 역사관</div>
                    <div className="museum-subtitle">
                      Balk's Village Histroy Hall
                    </div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">설립년도</div>
                    <div className="intro-text">2021년 설립</div>

                    <div className="intro-title">위 치</div>
                    <div className="intro-text">강원도 / 홍천</div>

                    <div className="intro-title">비 고</div>
                    <div className="intro-text">1986년 설립한 홍천</div>
                    <div className="intro-text">백학마을 35주년 기념</div>
                  </div>
                </S.MuseumTextItem>
              </S.MuseumTextItemLine>

              <S.MuseumImgItemLine>
                <S.MuseumImgItem color={"#603913"}>
                  <div className="museum-item-top">
                    <div className="museum-item-title">영안역사기록관</div>
                    <div className="museum-item-subtitle">
                      YoungAn History Hall
                    </div>
                  </div>
                  <img src={Img001_1} alt="" className="museum-item-img" />
                </S.MuseumImgItem>
                <S.MuseumImgItem color={"#D7DF23"}>
                  <div className="museum-item-top">
                    <div className="museum-item-title">지게차 100주년 역사관</div>
                    <div className="museum-item-subtitle">
                      CLARK Centennial Hall
                    </div>
                  </div>
                  <img src={Img001_2} alt="" className="museum-item-img" />
                </S.MuseumImgItem>
                <S.MuseumImgItem color={"#A4C7A3"}>
                  <div className="museum-item-top">
                    <div className="museum-item-title">숭의역사관 (대방동)</div>
                    <div className="museum-item-subtitle">
                      Soongeui History Hall
                    </div>
                  </div>
                  <img src={Img001_3} alt="" className="museum-item-img" />
                </S.MuseumImgItem>
                <S.MuseumImgItem color={"#A97B50"}>
                  <div className="museum-item-top">
                    <div className="museum-item-title">숭의역사관 (남산)</div>
                    <div className="museum-item-subtitle">
                      Soongeui History Hall
                    </div>
                  </div>
                  <img src={Img001_4} alt="" className="museum-item-img" />
                </S.MuseumImgItem>
                <S.MuseumImgItem color={"#726658"}>
                  <div className="museum-item-top">
                    <div className="museum-item-title">숭의인물관</div>
                    <div className="museum-item-subtitle">
                      Hall of Soongeui Fame
                    </div>
                  </div>
                  <img src={Img001_5} alt="" className="museum-item-img" />
                </S.MuseumImgItem>
                <S.MuseumImgItem color={"#7783BD"}>
                  <div className="museum-item-top">
                    <div className="museum-item-title">백학마을 역사관</div>
                    <div className="museum-item-subtitle">
                      Baik’s Village History Hall
                    </div>
                  </div>
                  <img src={Img001_6} alt="" className="museum-item-img" />
                </S.MuseumImgItem>
              </S.MuseumImgItemLine>
            </div>
            <div className="eng">
              <S.MuseumTextItemLine>
                <S.MuseumTextItem color={"#603913"}>
                  <div className="museum-top">
                    <div className="museum-title">YoungAn <br /> History Hall</div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">Year of Establishment</div>
                    <div className="intro-text">2009</div>
                    <div className="intro-text-sm">※YoungAn 50th Anniversary</div>

                    <div className="intro-title">Location</div>
                    <div className="intro-text">Bucheon <br /> YoungAn Hat Headquarters</div>

                    <div className="intro-title">Note</div>
                    <div className="intro-text">Renovation in 2019</div>
                  </div>
                </S.MuseumTextItem>
                <S.MuseumTextItem color={"#D7DF23"}>
                  <div className="museum-top">
                    <div className="museum-title">CLACK <br /> Centennial Hall</div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">Year of Establishment</div>
                    <div className="intro-text">2017</div>
                    <div className="intro-text-sm">※100th Anniversary of the CLARK</div>

                    <div className="intro-title">Location</div>
                    <div className="intro-text">Factory in Changwon</div>
                    <div className="intro-text">Exhibition Hall in Bucheon</div>
                    <div className="intro-text">Factory in U.S.A</div>
                    <div className="intro-text"> Factory in Germany <br /> (Place in 4 Locations)</div>
                  </div>
                </S.MuseumTextItem>
                <S.MuseumTextItem color={"#A4C7A3"}>
                  <div className="museum-top">
                    <div className="museum-title">Soong Eui History Hall</div>
                    <div className="museum-subtitle">(Daebang-dong, Seoul)</div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">Year of Establishment</div>
                    <div className="intro-text">2003</div>
                    <div className="intro-text-sm">※Soong Eui Educational <br /> Foundation 100th Anniversary </div>

                    <div className="intro-title">Location</div>
                    <div className="intro-text">Daebang-dong in Seoul /</div>
                    <div className="intro-text"> Soong Eui Girl’s High Schoo</div>
                  </div>
                </S.MuseumTextItem>
                <S.MuseumTextItem color={"#A97B50"}>
                  <div className="museum-top">
                    <div className="museum-title">Soong Eui 110th Anniversary History Hall</div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">Year of Establishment</div>
                    <div className="intro-text">2013</div>
                    <div className="intro-text-sm">※Soong Eui Educational <br /> Foundation 110th Anniversary</div>

                    <div className="intro-title">Location</div>
                    <div className="intro-text">Namsan in Seoul /</div>
                    <div className="intro-text">Soong Eui Women’s University</div>

                    <div className="intro-title">Note</div>
                    <div className="intro-text">Partial Renovation for the</div>
                    <div className="intro-text">120th Anniversary in 2023</div>
                  </div>
                </S.MuseumTextItem>
                <S.MuseumTextItem color={"#726658"}>
                  <div className="museum-top">
                    <div className="museum-title">Hall of <br /> Soong Eui Fame</div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">Year of Establishment</div>
                    <div className="intro-text">2015</div>

                    <div className="intro-title">Location</div>
                    <div className="intro-text">Namsan in Seoul /</div>
                    <div className="intro-text">Soong Eui Women’s University</div>

                    <div className="intro-title">Note</div>
                    <div className="intro-text">Statue of Ahn Jung-geun</div>
                    <div className="intro-text">/ in 1959 <br /> (Independence movement)</div>
                  </div>
                </S.MuseumTextItem>
                <S.MuseumTextItem color={"#7783BD"}>
                  <div className="museum-top">
                    <div className="museum-title">Baik's village History Museum</div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">Year of Establishment</div>
                    <div className="intro-text">2021</div>

                    <div className="intro-title">Location</div>
                    <div className="intro-text">Gangwon State / <br /> Hongcheon </div>

                    <div className="intro-title">Note</div>
                    <div className="intro-text">Baik's village in Hongcheon, <br /> Korea in 1986</div>
                    <div className="intro-text">Baik's village 35th Anniversary</div>
                  </div>
                </S.MuseumTextItem>
              </S.MuseumTextItemLine>

              <S.MuseumImgItemLine>
                <S.MuseumImgItem color={"#603913"}>
                  <div className="museum-item-top">
                    <div className="museum-item-title">YoungAn History Hall</div>
                  </div>
                  <img src={Img001_1} alt="" className="museum-item-img" />
                </S.MuseumImgItem>
                <S.MuseumImgItem color={"#D7DF23"}>
                  <div className="museum-item-top">
                    <div className="museum-item-title">CLARK Centennial Hall</div>
                  </div>
                  <img src={Img001_2} alt="" className="museum-item-img" />
                </S.MuseumImgItem>
                <S.MuseumImgItem color={"#A4C7A3"}>
                  <div className="museum-item-top">
                    <div className="museum-item-title">Soong Eui History Hall</div>
                  </div>
                  <img src={Img001_3} alt="" className="museum-item-img" />
                </S.MuseumImgItem>
                <S.MuseumImgItem color={"#A97B50"}>
                  <div className="museum-item-top">
                    <div className="museum-item-title">Soong Eui 110th Anniversary History Hall</div>
                  </div>
                  <img src={Img001_4} alt="" className="museum-item-img" />
                </S.MuseumImgItem>
                <S.MuseumImgItem color={"#726658"}>
                  <div className="museum-item-top">
                    <div className="museum-item-title">Hall of Soong Eui Fame</div>
                  </div>
                  <img src={Img001_5} alt="" className="museum-item-img" />
                </S.MuseumImgItem>
                <S.MuseumImgItem color={"#7783BD"}>
                  <div className="museum-item-top">
                    <div className="museum-item-title">Baik's village History Museum</div>
                  </div>
                  <img src={Img001_6} alt="" className="museum-item-img" />
                </S.MuseumImgItem>
              </S.MuseumImgItemLine>
            </div>

            <PageTitle titleko={"영안역사관 / 외부"} titleeng={"YoungAn History Museum (Outside)"} />
            <img src={Img002} alt="" className="fullsize-map" />

            <div className="kor">
              <S.MuseumTextItemLine>
                <S.MuseumTextItem color={"#B19BCA"}>
                  <div className="museum-top">
                    <div className="museum-title">보석역사관</div>
                    <div className="museum-subtitle">
                      History Museum of Jewelry
                    </div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">설립년도</div>
                    <div className="intro-text">2016년 설립</div>
                    <div className="intro-text-sm">
                      ※보석 손님들에 대한 교육장소
                    </div>

                    <div className="intro-title">위 치</div>
                    <div className="intro-text">서울 종로 / </div>
                    <div className="intro-text">단성골드빌딩</div>
                  </div>
                </S.MuseumTextItem>
                <S.MuseumTextItem color={"#6D6E71"}>
                  <div className="museum-top">
                    <div className="museum-title">자동차미니역사관</div>
                    <div className="museum-subtitle">Automobile Museum</div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">설립년도</div>
                    <div className="intro-text">2021년 설립</div>
                    <div className="intro-text-sm">※인천 지역 / </div>
                    <div className="intro-text-sm">※어린이들을 위한 교육장소</div>

                    <div className="intro-title">위 치</div>
                    <div className="intro-text">부천 / 영안모자 본사</div>
                  </div>
                </S.MuseumTextItem>
                <S.MuseumTextItem color={"#9B8579"}>
                  <div className="museum-top">
                    <div className="museum-title">외교구락부 역사관</div>
                    <div className="museum-subtitle">
                      Diplomatic Club History Hall
                    </div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">설립년도</div>
                    <div className="intro-text">2013년 설립</div>
                    <div className="intro-text-sm">
                      ※민주화의 산실 50주년 기념
                    </div>

                    <div className="intro-title">위 치</div>
                    <div className="intro-text">서울 남산 / </div>
                    <div className="intro-text">숭의여자대학교 별관</div>
                  </div>
                </S.MuseumTextItem>
                <S.MuseumTextItem color={"#FBB040"}>
                  <div className="museum-top">
                    <div className="museum-title">방송역사관</div>
                    <div className="museum-subtitle">Broadcasting Museum</div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">설립년도</div>
                    <div className="intro-text">2007년 설립</div>
                    <div className="intro-text-sm">
                      ※방송 100주년 기념(1907년)
                    </div>

                    <div className="intro-title">위 치</div>
                    <div className="intro-text">부천 / OBS 경인 TV </div>

                    <div className="intro-title">비 고</div>
                    <div className="intro-text">운영중단 / 이전 중</div>
                  </div>
                </S.MuseumTextItem>
                <S.MuseumTextItem color={"#754D29"}>
                  <div className="museum-top">
                    <div className="museum-title">단성사영화역사관</div>
                    <div className="museum-subtitle">
                      Dansungsa Cinema History Hall
                    </div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">설립년도</div>
                    <div className="intro-text">2019년 설립</div>
                    <div className="intro-text-sm">※한국최초상설극장</div>
                    <div className="intro-text-sm">
                      ※한국최초연극, 영화상영 기념
                    </div>
                    <div className="intro-text-sm">※한국영화 100주년 기념</div>

                    <div className="intro-title">위 치</div>
                    <div className="intro-text">서울 종로 / </div>
                    <div className="intro-text">단성골드빌딩</div>
                  </div>
                </S.MuseumTextItem>
                <S.MuseumTextItem color={"#4D9AD4"}>
                  <div className="museum-top">
                    <div className="museum-title">천체우주역사관</div>
                    <div className="museum-subtitle">
                      Astronomy and Space Museum
                    </div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">설립년도</div>
                    <div className="intro-text">2029년 오픈 예정</div>
                    <div className="intro-text-sm">※인류와 지구를 살리고</div>
                    <div className="intro-text-sm">모든 생명을 살리는 일</div>

                    <div className="intro-title">위 치</div>
                    <div className="intro-text">제주</div>
                  </div>
                </S.MuseumTextItem>
              </S.MuseumTextItemLine>
            </div>
            <div className="eng">
              <S.MuseumTextItemLine>
                <S.MuseumTextItem color={"#B19BCA"}>
                  <div className="museum-top">
                    <div className="museum-title">Jewelry History Museum</div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">Year of Establishment</div>
                    <div className="intro-text">2016</div>
                    <div className="intro-text-sm">
                      ※Educational Place for Jewelry Guest
                    </div>

                    <div className="intro-title">Location</div>
                    <div className="intro-text">Jongno-gu in Seoul / </div>
                    <div className="intro-text">Dansung Gold Building</div>
                  </div>
                </S.MuseumTextItem>
                <S.MuseumTextItem color={"#6D6E71"}>
                  <div className="museum-top">
                    <div className="museum-title">Automobile History Museum</div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">Year of Establishment</div>
                    <div className="intro-text">2021</div>
                    <div className="intro-text-sm">※Incheon Area / </div>
                    <div className="intro-text-sm">Educational Place for Children</div>

                    <div className="intro-title">Location</div>
                    <div className="intro-text">Bucheon / <br /> YoungAn Hat Headquarters</div>
                  </div>
                </S.MuseumTextItem>
                <S.MuseumTextItem color={"#9B8579"}>
                  <div className="museum-top">
                    <div className="museum-title">Diplomatic Club History Museum</div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">Year of Establishment</div>
                    <div className="intro-text">2013</div>
                    <div className="intro-text-sm">
                      ※Heartland of Democratization 50th Anniversary
                    </div>

                    <div className="intro-title">Location</div>
                    <div className="intro-text">Namsan in Seoul / </div>
                    <div className="intro-text">Soong Eui Women’s University Annex Building</div>
                  </div>
                </S.MuseumTextItem>
                <S.MuseumTextItem color={"#FBB040"}>
                  <div className="museum-top">
                    <div className="museum-title">Broadcasting History Museum</div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">Year of Establishment</div>
                    <div className="intro-text">2007</div>
                    <div className="intro-text-sm">
                      ※Broadcasting 100th Anniversary (1907)
                    </div>

                    <div className="intro-title">Location</div>
                    <div className="intro-text">Bucheon / OBS Gyeongin TV</div>

                    <div className="intro-title">Note</div>
                    <div className="intro-text">Currently Closed / Preparing for Relocation</div>
                  </div>
                </S.MuseumTextItem>
                <S.MuseumTextItem color={"#754D29"}>
                  <div className="museum-top">
                    <div className="museum-title">Dansungsa Movie History Museum</div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">Year of Establishment</div>
                    <div className="intro-text">2019</div>
                    <div className="intro-text-sm">※The First Permanent Theater in Korea</div>
                    <div className="intro-text-sm">
                      ※The Anniversary of the First Play and Movie Screening in Korea
                    </div>
                    <div className="intro-text-sm">※100th Anniversary of Korean Movies</div>

                    <div className="intro-title">Location</div>
                    <div className="intro-text">Jongno-gu in Seoul /</div>
                    <div className="intro-text">Dansung Gold Building</div>
                  </div>
                </S.MuseumTextItem>
                <S.MuseumTextItem color={"#4D9AD4"}>
                  <div className="museum-top">
                    <div className="museum-title">Astronomy and Space Museum</div>
                  </div>
                  <div className="museum-bottom">
                    <div className="intro-title">Year of Establishment</div>
                    <div className="intro-text">Planned to open in 2029</div>
                    <div className="intro-text-sm">※Work of Saving the Earth, </div>
                    <div className="intro-text-sm">Saving Humanity and Saving Lives</div>

                    <div className="intro-title">Location</div>
                    <div className="intro-text">Jeju</div>
                  </div>
                </S.MuseumTextItem>
              </S.MuseumTextItemLine>
            </div>

            <S.MuseumImgItemLine>
              <S.MuseumImgItem color={"#B19BCA"}>
                <div className="museum-item-top">
                  <div className="kor">
                    <div className="museum-item-title">보석역사관</div>
                    <div className="museum-item-subtitle">
                      History Museum of Jewelry
                    </div>
                  </div>
                  <div className="eng">
                    <div className="museum-item-title">History Museum of Jewelry</div>
                  </div>
                </div>
                <img src={Img002_1} alt="" className="museum-item-img" />
              </S.MuseumImgItem>
              <S.MuseumImgItem color={"#6D6E71"}>
                <div className="museum-item-top">
                  <div className="kor">
                    <div className="museum-item-title">자동차미니역사관</div>
                    <div className="museum-item-subtitle">Automobile Museum</div>
                  </div>
                  <div className="eng">
                    <div className="museum-item-title">Automobile Museum</div>
                  </div>
                </div>
                <img src={Img002_2} alt="" className="museum-item-img" />
              </S.MuseumImgItem>
              <S.MuseumImgItem color={"#9B8579"}>
                <div className="museum-item-top">
                  <div className="kor">
                    <div className="museum-item-title">외교구락부 역사관</div>
                    <div className="museum-item-subtitle">
                      Diplomatic Club History Hall
                    </div>
                  </div>
                  <div className="eng">
                    <div className="museum-item-title">Diplomatic Club History Hall</div>
                  </div>
                </div>
                <img src={Img002_3} alt="" className="museum-item-img" />
              </S.MuseumImgItem>
              <S.MuseumImgItem color={"#FBB040"}>
                <div className="museum-item-top">
                  <div className="kor">
                    <div className="museum-item-title">방송역사관</div>
                    <div className="museum-item-subtitle">
                      Broadcasting Museum
                    </div>
                  </div>
                  <div className="eng">
                    <div className="museum-item-title">Broadcasting Museum</div>
                  </div>
                </div>
                <img src={Img002_4} alt="" className="museum-item-img" />
              </S.MuseumImgItem>
              <S.MuseumImgItem color={"#754D29"}>
                <div className="museum-item-top">
                  <div className="kor">
                    <div className="museum-item-title">단성사영화역사관</div>
                    <div className="museum-item-subtitle">
                      Dansungsa Cinema History Hall
                    </div>
                  </div>
                  <div className="eng">
                    <div className="museum-item-title">Dansungsa Cinema History Hall</div>
                  </div>
                </div>
                <img src={Img002_5} alt="" className="museum-item-img" />
              </S.MuseumImgItem>
              <S.MuseumImgItem color={"#4D9AD4"}>
                <div className="museum-item-top">
                  <div className="kor">
                    <div className="museum-item-title">천체우주역사관</div>
                    <div className="museum-item-subtitle">
                      Astronomy and Space Museum
                    </div>
                  </div>
                  <div className="eng"><div className="museum-item-title">Astronomy and Space Museum</div>
                  </div>
                </div>
                <img src={Img002_6} alt="" className="museum-item-img" />
              </S.MuseumImgItem>
            </S.MuseumImgItemLine>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default Scholarship;
